export default {
  apikey: "",
  apiBaseUrl: "https://swapi.dev/api/",
  apiPlanetsUrl: "https://swapi.dev/api/planets",
  // apiBaseUrl: "http://localhost:8080/",
  // apiPlanetsUrl: "http://localhost:8080/planets",
};
